<template>
  <div class="ac1">
    <div class="container">
      <!-- 主容器 -->
      <div class="index-con">
        <!-- 左侧 -->
        <div class="index-l">
          <!-- 导航 -->
          <div class="index-title">
            <span>最新热门</span>
          </div>
          <!-- 循环项 -->
          <div
            class="list-item"
            v-for="(item, index) in this.data"
            :key="index"
            @click="goDetails(item.id)"
          >
            <!-- 左侧图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
            </div>
            <!-- 右侧信息 -->
            <div class="item-info">
              <!-- 标题 -->
              <div class="item-title">{{ item.title }}</div>
              <!-- 发布时间 -->
              <div class="item-time">发布时间:{{ item.time }}</div>
              <!-- 简介 -->
              <div class="item-jj">
                {{ item.jj }}
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="index-r">
          <!-- 标题 -->
          <div class="r-title">
            <span>实时快讯</span>
            <span>更多</span>
          </div>

          <!-- 循环项 -->
          <div
            class="r-item"
            v-for="(item, index) in data2"
            :key="index"
            @click="goDetails(item.id)"
          >
            <!-- 时间 -->
            <div class="r-time">
              <!-- 原点 -->
              <div class="r-rd"></div>
              <span>2021-3-1</span>
            </div>

            <!-- 标题 -->
            <div class="r-name">
              <h2>{{ item.title }}</h2>
            </div>

            <!-- 简介 -->
            <div class="r-jj">
              <p>
                {{ item.jj }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "北京盛云科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        this.data = data.splice(5, 9);
        this.data2 = data.splice(0, 6);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
      }
      // 未登录
      if (this.state !== 0) {
        alert("请登录付费3元后可浏览！！！~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac1 {
  .container {
    margin-top: 120px;
    // 主容器
    .index-con {
      width: 100%;
      // height: 1800px;
      margin-top: 60px;
      // @include flex();
      display: flex;
      justify-content: space-between;

      // 左侧
      .index-l {
        width: 70%;
        height: 100%;
        background-color: #fff;
        padding-left: 20px;
        box-sizing: border-box;
        // 标题层
        .index-title {
          width: 100%;
          height: 60px;
          border-bottom: 1px solid #ccc;
          display: flex;
          align-items: center;
          span {
            font-size: 18px;
            margin-right: 25px;
            color: #797c80;
            cursor: pointer;
            font-weight: bold;
          }
        }

        // 循环项
        .list-item {
          width: 100%;
          height: 300px;
          border-bottom: 1px solid #cfcfcf;
          @include flex();
          // 左侧图片
          .item-img {
            width: 25%;
            height: 100%;
            // background-color: #c60023;
            text-align: center;
            img {
              width: 220px;
              height: 220px;
              margin-top: 56px;
            }
          }
          // 右侧信息
          .item-info {
            width: 65%;
            // 标题
            .item-title {
              font-size: 21px;
              transition: all 0.2s;
              cursor: pointer;
              &:hover {
                color: #1985ff;
              }
            }
            // 发布时间
            .item-time {
              font-size: 16px;
              color: #666;
              margin: 15px auto;
            }
            // 简介
            .item-jj {
              font-size: 14px;
              line-height: 35px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 400px;
            }
          }
        }
      }
      // 右侧
      .index-r {
        width: 30%;
        height: 100%;
        background-color: #fff;
        margin-left: 20px;

        // 标题
        .r-title {
          width: 100%;
          height: 60px;
          padding: 0 15px;
          box-sizing: border-box;
          @include flex();
          border-bottom: 1px solid #1985ff;
          span {
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            font-weight: bold;
            &:nth-child(2) {
              transition: all 0.2s;
              font-size: 12px;
              &:hover {
                color: #1985ff;
              }
            }
          }
        }

        // 循环项
        .r-item {
          width: 100%;
          height: 240px;
          // background-color: pink;
          margin: 20px auto;
          padding: 20px;
          box-sizing: border-box;
          // 时间
          .r-time {
            width: 100%;
            display: flex;
            // 圆点
            .r-rd {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #1985ff;
              margin-right: 15px;
            }
            span {
              font-size: 12px;
              color: #999999;
            }
          }

          // 标题
          .r-name {
            padding-left: 22px;
            box-sizing: border-box;
            margin: 15px 0;
            h2 {
              font-size: 18px;
              font-weight: 300;
            }
          }
          // 简介
          .r-jj {
            padding-left: 22px;
            box-sizing: border-box;
            p {
              font-size: 14px;
              color: #797c80;
            }
          }
        }
      }
    }
  }
}
</style>